import Marquee from "react-fast-marquee";

const ITEMS = [
  { name: "Kunzea", logo: "/sponsors/kunzea.png" },
  { name: "Bawang Goreng Sumringah", logo: "/sponsors/sumringah.png" },
  { name: "Seveneight Sportainment", logo: "/sponsors/seveneight.png" },
  { name: "KopiMage", logo: "/sponsors/kopimage.png" },
];

export default function SponsorMarquee() {
  return (
    <section
      data-testid="sponsor-marquee-section"
      className="relative bg-[#E63946] border-y-2 border-black/10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex items-center gap-8">
        <div className="hidden sm:flex flex-col flex-shrink-0 pr-8 border-r border-white/30">
          <span className="font-display text-2xl text-white leading-none">SPONSOR</span>
          <span className="text-[10px] text-white/80 tracking-[0.3em]">RESMI TIM</span>
        </div>

        <div className="flex-1 overflow-hidden">
          <Marquee
            data-testid="sponsor-marquee"
            direction="right"
            speed={50}
            gradient={false}
            pauseOnHover
          >
            {ITEMS.concat(ITEMS, ITEMS).map((s, i) => (
              <div
                key={i}
                data-testid={`sponsor-item-${i}`}
                className="flex items-center mx-10 sm:mx-14"
              >
                <img
                  src={s.logo}
                  alt={s.name}
                  className="h-12 sm:h-14 w-auto object-contain opacity-90 hover:opacity-100 transition-opacity"
                />
              </div>
            ))}
          </Marquee>
        </div>
      </div>
    </section>
  );
}
